import resize from '../resize';
import IMask from 'imask';
import vanillaToast from 'vanilla-toast';
import axios from 'axios';
import metrics from '../metrics';

const form = () => {
  //const citizenRequestTGU ='https://localhost:44328/CitizenRequest/InternalNewRequest'; // debug

  const formCitizenRequest = 'https://2025.api.tgu-dpo.ru/citizenrequest/InternalNewRequest',
    citizenRequestCommerce = "https://2025.api.tgu-dpo.ru/citizenrequest/NewInternationalCommerceRequest",
    crmRequest = "https://sigmaedu.ru/profi/handler.php",
    citizenRequestTop5ProgramsTGU = 'https://2025.api.tgu-dpo.ru/regions/GetTop5ForRegions',
    INSTRUCTION = '/files/documents/INSTRUCTION.pdf';

  /* Замена текста в зависимости от ширины экрана */
  function resizeForm() {
    const text = document.querySelector('.form__info-change');

    if (!text) {
      return;
    }

    if (innerWidth > 996) {
      text.innerHTML = 'справа';
    } else {
      text.innerHTML = 'снизу';
    }
  }

  const invalidCharsRegex = /[^a-zA-Z0-9.@_-]/; // Разрешённые символы

  $('[type=email]').on('input', function() {
      const inputValue = $(this).val();

      // Проверяем наличие недопустимых символов
      const invalidChars = inputValue.match(invalidCharsRegex);
      const input = $(this).get(0);
      const inputParent = $(this).parent().get(0);

      if (input.classList.contains('form-invalid')) {
        input.classList.remove('form-invalid');
        inputParent.querySelector('.form-error')?.remove();
      }
      const error = {};

      if (invalidChars) {
        error.message = `Недопустимый символ: "${invalidChars[0]}"`;
        input.classList.add('form-invalid');

        showError(error, inputParent)
      }
  });

  // Подсказки для ввода почты
  const validDomains = ['yandex.ru', 'mail.ru', 'gmail.com', 'hotmail.com', 'outlook.com'];

  $('[type=email]').on('input', function() {
    const emailInput = $(this);
    const emailValue = emailInput.val();
    const suggestionsDiv = emailInput.siblings('.suggestions');

    const atIndex = emailValue.indexOf('@');
    if (atIndex !== -1) {
        const domainPart = emailValue.slice(atIndex + 1);
        const suggestions = validDomains.filter(domain => domain.startsWith(domainPart));
        suggestionsDiv.empty(); // Очистка предыдущих подсказок

        if (suggestions.length > 0) {
            suggestions.forEach(domain => {
                suggestionsDiv.append(`<span class="suggestion-item">${emailValue.slice(0, atIndex + 1)}${domain}</span>`);
            });
            suggestionsDiv.show();
        } else {
            suggestionsDiv.hide();
        }
    } else {
        suggestionsDiv.hide();
    }
  });

  // Обработчик клика на предложениях
  $(document).on('click', '.suggestion-item', function() {
      const emailInput = $(this).closest('form').find('[type=email]');
      emailInput.val($(this).text()).focus();
      emailInput.siblings('.suggestions').hide();
  });

  /* Валидаторы */
  const validators = {
    requried: function (value, error) {
      if (!value || value.length === 0) {
        error.message = 'Это поле обязательно';
        return false;
      } else {
        return true;
      }
    },
    phone: function (value, error) {
      if (/^((\+7|7|8)\s?\(?(\d{3})\)?[\s-]?(\d{3})[\s-]?(\d{2})[\s-]?(\d{2}))$/.test(value)) {
        return true;
      } else {
        error.message = "Некорректный номер телефона";
        return false;
      }
    },
    email: function (value, error) {
      if (/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
        return true;
      } else {
        error.message = "Некорректный email";
        return false;
      }
    },
    birthday: function (value, error) {
      var parts = value.split('.');
      if (
        parts.length != 3 ||
        parts[0].length != 2 ||
        parts[1].length != 2 ||
        parts[2].length != 4
      ) {
        error.message = 'Некорректная дата рождения';
        return false;
      }

      return true;
    },
  };

  /* Добавление ошибок валидации */
  function showError(error, field) {
    if (error.message) {
      var errorContainer = document.createElement('div');
      errorContainer.textContent = error.message;
      errorContainer.classList.add('form-error');
      field.appendChild(errorContainer);
    }
  }

  /* Удаление ошибок валидации */
  function deleteErrors(form) {
    form.querySelectorAll('.form-error').forEach(function (el) {
      el.remove();
    });
    form.querySelectorAll('.form-invalid').forEach(function (el) {
      el.classList.remove('form-invalid');
    });
  }

  /* Валидация формы */
  function validate(form) {
    let result = true;

    Array.from(form.querySelectorAll('.form__field')).forEach(function (
      formField
    ) {
      let error = {},
        control = formField.querySelector('select, input, textarea');

      if (formField.querySelector('.form-required')) {
        if (!validators.requried(control.value, error)) {
          showError(error, formField);
          control.classList.add('form-invalid');
          result = false;
          return;
        }
      }

      if (control.type === "tel") {
        if (!validators.phone(control.value, error)) {
          showError(error, formField);
          control.classList.add("form-invalid");
          result = false;
        }
      }

      if (control.type === "email") {
        if (!validators.email(control.value, error)) {
          showError(error, formField);
          control.classList.add("form-invalid");
          result = false;
        }
      }

      if (control.id === 'birthday') {
        if (!validators.birthday(control.value, error)) {
          showError(error, formField);
          control.classList.add('form-invalid');
          result = false;
        }
      }
    });

    let invalidField = form.querySelector('.form-invalid');
    if (invalidField) {
      invalidField.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }

    return result;
  }

  /* Получения cookie */
  function getCookie(cname) {
    let name = cname + '=',
      decodedCookie = decodeURIComponent(document.cookie),
      ca = decodedCookie.split(';');

    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];

      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }

      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }

    return '';
  }

  /* Проверка ИНН */
  function validateInn(INN) {
    var result = false;
    let inn = +INN;
    
    if (typeof inn === 'number') {
      inn = inn.toString();
    } else if (typeof inn !== 'string') {
      inn = '';
    }

    if (!inn.length) {
      result = false;
    } else if (/[^0-9]/.test(inn)) {
      result = false;      
    } else if ([10].indexOf(inn.length) === -1) {
      result = false;      
    } else {
      result = true;    
    }

    return result;
  }

  /* Отправка формы */
  async function send(form, e, modalData) {
    let sendBtn = form.querySelector(
        'button[type="submit"], input[type="submit"]'
      ),
      data = {};

    if (modalData) {
      data = { ...modalData };
    } else {
      e.preventDefault();
      deleteErrors(form);

      data = {};

      if (!validate(form)) {
        return;
      }

      Array.from(new FormData(form)).forEach(function (formElement) {
        let key = formElement[0],
          value = formElement[1];

        if (key == 'BirthDate') {
          data[key] = value.split('.').reverse().join('-');
        } else if (key == 'Region') {
          data[key] = returnRegionName('#Regions option', value);
          data['RegionId'] = value;
        } else if (key == "ParticipantNumber") {
          if (validateInn(value)) {
            data["ParticipantNumber"] = value;
          } else {
            data["ParticipantNumber"] = "";
          }
        } else {
          data[key] = value;
        }
      });
    }

    sendBtn.disabled = true;

    let url = document.location.href,
      paramsStartIndex = url.indexOf('?');

    if (paramsStartIndex > -1) {
      url
        .slice(paramsStartIndex + 1, url.length)
        .split('&')
        .map(function (utmString) {
          return utmString.split('=');
        })
        .forEach(function (utmMark) {
          var key = utmMark[0];
          key = key[0].toUpperCase() + key.slice(1, key.length);
          var value = utmMark[1];
          value =
            value.indexOf('#') > -1
              ? value.slice(0, value.indexOf('#'))
              : value;
          data[key] = value;
        });
    }

    data['Landing'] = url.split('?')[0] || url;

    /* Добавление данных в передачу формы */
    const programList = document.querySelector('#Program')?.children,
      programHidden = form.querySelector('.program-hidden'),
      programListModal = document.querySelector('#Program-modal')?.children;

    if (programList && programListModal) {
      [...programList, ...programListModal].forEach((item) => {
        if (data['Program'] == item.value) {
          data['Operator'] = item.getAttribute('operator');
          data['ProgramOwner'] = item.getAttribute('programowner');

          if (item.getAttribute('linkrvr') != 'undefined') {
            data['LinkRVR'] = item.getAttribute('linkrvr');
            data['OdinId'] = item.getAttribute('odinid');
          }
        }
      });
    } else if (programList && !programHidden) {
      [...programList].forEach((item) => {
        if (data['Program'] == item.value) {
          data['Operator'] = item.getAttribute('operator');
          data['ProgramOwner'] = item.getAttribute('programowner');

          if (item.getAttribute('linkrvr') != 'undefined') {
            data['LinkRVR'] = item.getAttribute('linkrvr');
            data['OdinId'] = item.getAttribute('odinid');
          }
        }
      });
    } else {
      data['Operator'] = programHidden.getAttribute('operator');
      data['ProgramOwner'] = programHidden.getAttribute('programowner');

      if (programHidden.getAttribute('linkrvr') != 'undefined') {
        data['LinkRVR'] = programHidden.getAttribute('linkrvr');
        data['OdinId'] = programHidden.getAttribute('odinid');
      }
    }

    if (data['OdinId'] == undefined) {
      data['OdinId'] = null;
    }

    let ym_uid = getCookie('_ym_uid');
    if (ym_uid) {
      data['ClientId'] = ym_uid;
    }

    /* Получение UTM меток из cookie */
    if (getCookie("utm_tags")) {
    getCookie("utm_tags")
      .slice(paramsStartIndex + 1, getCookie("utm_tags").length)
      .split("&")
      .map(function (utmString) {
        return utmString.split("=");
      })
      .forEach(function (utmMark) {
        var key = utmMark[0];
        key = key[0].toUpperCase() + key.slice(1, key.length);
        var value = utmMark[1];
        value =
          value.indexOf("#") > -1
            ? value.slice(0, value.indexOf("#"))
            : value;
        data[key] = value;
      });
    }

    /* AdvCake cookie берем до удаления cookie */
    let advcakeCookie = getCookie('advcake_track_id');

    /* Ройстат */
    let roistatCookie = getCookie("roistat_visit");
    if (!!roistatCookie) {
      if (data["Operator"] == "IRPO") {
        data["RoistatCookie"] = "111111";
      } else {
        data["RoistatCookie"] = roistatCookie;
      }
    }

    /* Ссылка по отправке формы в базу данных в зависимости от оператора */
    let citizenRequest = '';
    if (data["Operator"] == "TGU") {
      citizenRequest = formCitizenRequest;
    } else {
      citizenRequest = citizenRequestCommerce;
    }

    axios
      .post(citizenRequest, data)
      .then(function (result) {
        sendBtn.disabled = false;
        onSuccess(data);

        /* Метрики */
        VK.Goal('lead');
        fbq('track', 'Lead');
        VK.Retargeting.Event('lead');
        ym(94760218, 'reachGoal', 'submit_form');
        var _tmr = window._tmr || (window._tmr = []);
        _tmr.push({ id: '3244339', type: 'reachGoal', goal: 'lead' });
        _tmr.push({ type: 'reachGoal', id: 3413771, goal: 'lead' });

        if (data['EmploymentFormat'] === '2') {
          ym(94760218, 'reachGoal', 'submit_form_trud');
          _tmr.push({ type: 'reachGoal', id: 3413771, goal: 'lead_trud' });
        }

        addAdvCakeScript(
          result.data.requestId,
          result.data.odinId,
          result.data.programName,
          data.Email,
          advcakeCookie
        );

        /* Отправка в АМО всех операторов, кроме ТГУ */
        if (data["Operator"] != "TGU") {
          formSubmitAmo(data);
        } 

        form.reset();
        $('#Category').val('').trigger('change');
        $('#Category-modal').val('').trigger('change');
      })
      .catch(function (error) {
        console.log(error);
        sendBtn.disabled = false;
        vanillaToast.error(
          'Пожалуйста, проверьте ваше соединение с сетью или повторите попытку позже',
          { duration: 3000, fadeDuration: 500 }
        );
      });
  }

  /* Отправка формы в АМО */
  function formSubmitAmo(data) {
    axios
      .post(crmRequest, data)
  }

  /* Установка форм */
  function setForm(selector) {
    var form = document.querySelector(selector);

    if (!form) {
      return;
    }

    form.addEventListener('submit', function (e) {
      send(form, e);
    });

    onFormFilling(form, () => {
      ym(94760218, 'reachGoal', 'FormStart');
      fbq('track', 'InitiateCheckout');
    });
  }

  /* Блокировка кнопки отправки формы */
  function setFormCheckbox(arr, btn) {
    try {
      arr.forEach((item) => {
        item.addEventListener('change', function () {
          if (!arr.find((checkbox) => !checkbox.checked)) {
            btn.removeAttribute('disabled');
          } else {
            btn.setAttribute('disabled', 'disabled');
          }
        });
      });
    } catch (e) {}
  }

  /* Получение Топ 5 программ для всех регионов */
  let Top5ProgramsTGU = [];

  async function getTop5Programs() {
    Top5ProgramsTGU = await getJson(citizenRequestTop5ProgramsTGU);
  }

  /* Функция успешной отправки формы */
  function onSuccess(data = null) {
    if (data !== null) {
      if (data.LinkRVR && data.LinkRVR !== 'undefined') {
        let urlRvR = data.LinkRVR;
        /* FLOW-12326 */
        // successRedirectModal(urlRvR, data['Operator']);

        setTimeout(() => {
          const newTab = window.open(urlRvR, '_blank');
          if (newTab) {
            newTab.focus();
          } else {
            window.location.assign(urlRvR);
          }
        }, 0);
      } else {
        if (data['TrainingFormat'] == 'offline') {
          successModal(data['Operator'], false)
        } else {
          successModal(data['Operator'], false)
        }
      }
    }
  }

  /* Модальное окно после отправки формы с редиректом */
  function successRedirectModal(urlRvR, operator) {
    let modal = document.querySelector('.success__modal'),
      btn = document.querySelector('.success__modal-open');

    /* Добавляем ссылку на скачивание инструкции */
    // const downloadInstruction = document.createElement("a");
    // downloadInstruction.setAttribute("download", "");
    // downloadInstruction.style.display = "none";
    // document.body.append(downloadInstruction);    
    // downloadInstruction.href = INSTRUCTION;
    // downloadInstruction.click();

    if (!modal) {
      modal = document.createElement('div');
      modal.classList.add('success__modal', 'custom-modal__hidden');
      modal.id = 'success__modal';
      document.body.append(modal);
    }

    modal.innerHTML = `
      <h4>Поздравляем с&nbsp;успешной регистрацией!</h4>
      <p>Далее вам необходимо подтвердить заявку на&nbsp;портале &laquo;Работа в&nbsp;России&raquo; в&nbsp;течение 3&nbsp;дней.</p>
      <p class="сountdown">
        Через <strong><span class="timer">15</span> секунд</strong> вы будете автоматически перенаправлены на&nbsp;портал <a class="success__modal-link timer" href="${urlRvR}" target="_blank"><b class="note">«Работа России»</b></a>
      </p>
      <p><b>Это обязательное условие для участия в&nbsp;проекте &laquo;Содействие занятости&raquo;.</b></p>
      <div class="important">
        <div class="important__content">
          <p>На&nbsp;указанную почту мы&nbsp;пришлем <span>подробные инструкции</span> как:</p>
          <p><span>&#149;&nbsp;пройти все шаги</span> до&nbsp;зачисления на&nbsp;программу;</p>
          <p><span>&#149;&nbsp;вступить в&nbsp;чат</span> программы;</p>
          <p><span>&#149;&nbsp;начать обучение</span> в&nbsp;ближайшей группе.</p>
          <p><b>Не&nbsp;забывайте проверять папку &laquo;Спам&raquo;.</b></p>
        </div>
      </div>
      <div class="success__modal-bottom">
        <p>Остались вопросы? Напишите в&nbsp;<a class="TelegramClickSZ ${
          operator == 'TGU' ? 'TelegramBotClick' : ''
        }" href="https://t.me/TGUinfoBot" rel="nofollow noopener noreferrer" target="_blank">Telegram-бот</a>, наши кураторы ответят на&nbsp;все вопросы и&nbsp;помогут найти решение, расскажут как работодателю подписать договор о&nbsp;намерениях.</p>
        <a href="https://t.me/TGUinfoBot" class="btn TelegramClickSZ ${
          operator == 'TGU' ? 'TelegramBotClick' : ''
        }" rel="nofollow noopener noreferrer" target="_blank">Вступить&nbsp;в&nbsp;чат&nbsp;программы</a>
      </div>
    `;

    setTimerRedirect(modal.querySelector('.timer'));

    if (!btn) {
      btn = document.createElement('button');
      btn.classList.add('success__modal-open');
      btn.setAttribute('data-modal-id', 'success__modal');
      btn.setAttribute('data-modal-open', '');
      btn.style.display = 'none';

      document.body.append(btn);
    }

    btn.click();
    document.querySelector('.custom-modal-close').style.display = 'none';
    document.querySelector('.custom-modal__overlay').style.pointerEvents =
      'none';

    /* Запуск метрики для кнопки телеграм в модальных окнах */
    metrics();
  }

  /* Создание модального окна со ссылками на РВР Топ 5 программ региона */
  function modalTop5Programs(operator, region) {
    let data = [];

    Top5ProgramsTGU.forEach((item) => {
      if (item.regionId == region) {
        data = item.programsSuggestions;
      }
    });

    if (data.length < 1) {
      successModal(operator, false);
      return;
    }

    let a = document.querySelector('.ProgramsModal__btn'),
      modal = document.createElement('div'),
      modalRegions = document.querySelector('.modal-programs');

    /* Очищаем модальное окно */
    if (modalRegions) {
      modalRegions.remove();
    }

    /* Создаем модальное окно */
    if (!a) {
      (a = document.createElement('button')),
        a.setAttribute('data-modal-open', '');
      a.setAttribute('data-modal-id', 'ProgramsModal');
      a.classList.add('ProgramsModal__btn');
      a.style.display = 'none';
      document.body.append(a);
    }

    /* Модальные окна */
    modal.classList.add('custom-modal__hidden', 'modal-programs');
    modal.id = 'ProgramsModal';
    modal.innerHTML = `<div class="modal-programs__content">
      <h3>К сожалению, в вашем регионе программа не&nbsp;реализуется</h3>
      <p>Но вы все еще можете пройти <strong>бесплатное обучение</strong>
      и получить помощь в старте карьеры по другим программам. Вот какие программы доступны в вашем регионе:</p>
      <div class="modal-programs__links"></div>
      </div>`;
    document.body.append(modal);

    /* Заполняем список доступных программ. Также проверка на наличие shortname на лендинг */
    data.forEach((item) => {
      document.querySelector('.modal-programs__links').innerHTML += `
          <a href="${item.rvrLink}" target="_blank">${item.programName}</a>
        `;
    });

    a.click();
    a.remove();
  }

  /* Модальное окно после отправки формы */
  function successModal(operator, isJobSeeker = true) {
    /* Добавляем ссылку на скачивание лида */
    const downloadLead = document.createElement('a');
    downloadLead.href ='/files/documents/Instruction_TGU_1.pdf';
    downloadLead.setAttribute('download', '');
    downloadLead.style.display = 'none';
    document.body.append(downloadLead);
    downloadLead.click();

    let modal = document.querySelector('.success__modal'),
      btn = document.querySelector('.success__modal-open'),
      botLink;

    if (operator == 'TGU') {
      botLink = 'https://salebot.site/ff4cf9b214c75cd7e132af3c2a07fa7a_1';
    } else {
      botLink = 'https://t.me/SigmaszBot';
    }

    if (!modal) {
      modal = document.createElement('div');
      modal.classList.add('success__modal', 'custom-modal__hidden');
      modal.id = 'success__modal';
      document.body.append(modal);
    }

    if (isJobSeeker) { 
      modal.innerHTML = /*html*/ `
        <h4>Благодарим за заявку!</h4>
        <p>Для зачисления на&nbsp;обучение вам необходимо создать резюме, заполнить заявление и&nbsp;подтвердить заявку на&nbsp;портале &laquo;Работа России&raquo;.</p>
        <p><b>Это обязательное условие, которое не&nbsp;обязывает вас менять работодателя или искать новую работу, если вы&nbsp;уже официально трудоустроены.</b></p>
        <div class="important">
          <div class="important__content">
            <p>На&nbsp;указанную почту мы&nbsp;пришлем <span>подробные инструкции</span> как:</p>
            <p><span>&#149;&nbsp;пройти все шаги</span> до&nbsp;зачисления на&nbsp;программу;</p>
            <p><span>&#149;&nbsp;вступить в&nbsp;чат</span> программы;</p>
            <p><span>&#149;&nbsp;начать обучение</span> в&nbsp;ближайшей группе.</p>
            <p><b>Не&nbsp;забывайте проверять папку &laquo;Спам&raquo;.</b></p>
          </div>
        </div>
        <div class="success__modal-bottom">
          <p>Остались вопросы? Напишите в&nbsp;<a class="TelegramClickSZ ${
            operator == 'TGU' ? 'TelegramBotClick' : ''
          }" href="https://t.me/TGUinfoBot" rel="nofollow noopener noreferrer" target="_blank">Telegram-бот</a>, наши кураторы ответят на&nbsp;все вопросы и&nbsp;помогут найти решение, расскажут как работодателю подписать договор о&nbsp;намерениях.</p>
          <a href="https://t.me/TGUinfoBot" class="btn TelegramClickSZ ${
            operator == 'TGU' ? 'TelegramBotClick' : ''
          }" rel="nofollow noopener noreferrer" target="_blank">Вступить&nbsp;в&nbsp;чат&nbsp;программы</a>
        </div>
      `;
    } else {
      modal.innerHTML = `
        <div class="success__modal-content">
          <h4>Благодарим за заявку!</h4>
          <p>Ваша заявка попала в&nbsp;список приоритетных кандидатов.</p>
          <p class="сountdown">
              Мы&nbsp;сообщим вам о&nbsp;дате возобновления набора. Далее вам будет необходимо подтвердить заявку на&nbsp;портале <a class="success__modal-link" href="https://trudvsem.ru/educational-programs/card?id=deb5f368-8e0f-4a1b-ad05-9a92f7a8e649&amp;roistat_visit=5295406" target="_blank">«Работа России»</a>
          </p>
          <p><b>Это обязательное условие для участия в&nbsp;проекте &laquo;Содействие занятости&raquo;.</b></p>
          <p>На&nbsp;указанную почту мы&nbsp;отправили <span class="note">подробные инструкции</span>. С&nbsp;их&nbsp;помощью вы&nbsp;сможете пройти все шаги и&nbsp;подписать договор о&nbsp;намерениях от&nbsp;работодателя.</p>
          <p><b>Не&nbsp;забывайте проверять папку &laquo;Спам&raquo;.</b></p>                        
        </div>
        <div class="success__modal-image">
          <img src="/img/components/modal/letter.webp" loading="lazy" alt="Картинка с письмом">
        </div>
      `;
    }

    if (!btn) {
      btn = document.createElement('button');
      btn.classList.add('success__modal-open');
      btn.setAttribute('data-modal-id', 'success__modal');
      btn.setAttribute('data-modal-open', '');
      btn.style.display = 'none';

      document.body.append(btn);
    }

    btn.click();

    /* Запуск метрики для кнопки телеграм в модальных окнах */
    metrics();
  }

  /* Модальное окно после отправки формы категории ищущих*/
  function successModalForSeekers(operator) {
   
    window.location.href = '/steps-for-employed';
    /* Добавляем ссылку на скачивание лида */
    /*const downloadLead = document.createElement('a');
    downloadLead.href = '/files/documents/Instruction_TGU_1.pdf';
    downloadLead.setAttribute('download', '');
    downloadLead.style.display = 'none';
    document.body.append(downloadLead);
    downloadLead.click();

    let modal = document.querySelector('.success__modal'),
      btn = document.querySelector('.success__modal-open'),
      botLink;

    if (operator == 'TGU') {
      botLink = 'https://salebot.site/ff4cf9b214c75cd7e132af3c2a07fa7a_1';
    } else {
      botLink = 'https://t.me/SigmaszBot';
    }

    if (!modal) {
      modal = document.createElement('div');
      modal.classList.add('success__modal', 'custom-modal__hidden');
      modal.id = 'success__modal';
      document.body.append(modal);
    }

    modal.innerHTML = `
      <h4>Благодарим за&nbsp;заявку!</h4>
      <p>Для зачисления на&nbsp;обучение вам необходимо создать резюме, заполнить заявление и&nbsp;подтвердить заявку на&nbsp;портале &laquo;Работа России&raquo;.</p>
      <p style="margin-bottom: 0;"><b>Это обязательное условие, которое не&nbsp;обязывает вас менять работодателя или искать новую работу, если вы&nbsp;уже официально трудоустроены.</b></p>
      <div class="seekModal">
        <div class="seekModal__wrapper">
          <p class="seekModal__p">Воспользуйтесь нашей инструкцией, чтобы успешно пройти все дальнейшие шаги</p>
          <img class="seekModal__img" src="/img/instruction-modal.png" alt="Инструкция">
          <a href="/files/documents/Instruction_TGU_1.pdf" class="seekModal__link" target="_blank" rel="nofollow noopener noreferrer">Посмотреть инструкцию</a>
        </div>
      </div>
      <div class="success__modal-bottom seek__modal-bottom">
        <a class="seek-a-bottom"  href=${botLink} class="btn TelegramClickSZ ${
      operator == 'TGU' ? 'TelegramBotClick' : ''
    }" target="_blank" style="margin: 0 auto;">Вступить в чат </a>
        <p class="seek-p-bottom">В&nbsp;чате <a href=${botLink}  target="_blank"">Telegram-бота</a> вы&nbsp;узнаете о&nbsp;поиске работодателя, актуальные новости программы и&nbsp;вашего потока</p>
      </div>
    `;

    if (!btn) {
      btn = document.createElement('button');
      btn.classList.add('success__modal-open');
      btn.setAttribute('data-modal-id', 'success__modal');
      btn.setAttribute('data-modal-open', '');
      btn.style.display = 'none';

      document.body.append(btn);
    }

    btn.click();*/

    /* Запуск метрики для кнопки телеграм в модальных окнах */
    metrics();
  }

  /* Таймер редиректа */
  function setTimerRedirect(el) {
    if (!el) {
      console.error('Не передан элемент');
      return;
    }
    const interval = setInterval(() => {
      if (el.textContent === '0' || Number(el.textContent) < 1) {
        clearInterval(interval);
        return;
      }
      el.textContent = Number(el.textContent) - 1;
    }, 1000);
  }

  /* Начало заполнения формы */
  function onFormFilling(form, callback) {
    const controls = form.querySelectorAll('input, select, textarea');
    let changed = false;
    controls.forEach((control) => {
      $(control).one('blur', (e) => {
        if (!changed) {
          callback(e);
          changed = true;
        }
      });
    });
  }

  /* Запрос на получение json */
  async function getJson(patch) {
    let result;

    try {
      let response = await fetch(patch);
      result = await response.json();
    } catch (error) {
      console.log('Не удалось подключиться к базе');
    }

    return result;
  }

  /* Вызов функций */
  let phoneInput = document.getElementById('phone');
  let phoneModalInput = document.getElementById('phone-modal');

  if (phoneInput) {
    new IMask(phoneInput, {
      mask: '+{7} (000) 000-00-00',
    });
  }

  if (phoneModalInput) {
    new IMask(phoneModalInput, {
      mask: '+{7} (000) 000-00-00',
    });
  }

  /* Возвращает название региона для отправки формы */
  function returnRegionName(id, region) {
    let regionList = document.querySelectorAll(id);

    for (let i = 0; i < regionList.length; i++) {
      if (region == regionList[i].value) {
        return regionList[i].textContent;
      }
    }
  }

  /* Получение данных с форм в модальных окнах */
  function getFormModalData() {
    const forms = document.querySelectorAll('.formModal__modal-form');

    let data = {};
    [...forms].forEach((form) => {
      Array.from(new FormData(form)).forEach(function (formElement) {
        let key = formElement[0];
        let value = formElement[1];

        if (key == 'BirthDate') {
          data[key] = value.split('.').reverse().join('-');
        } else if (key == 'Region') {
          data[key] = returnRegionName('#Regions-modal option', value);
          data['RegionId'] = value;
        } else {
          data[key] = value;
        }
      });

      form.reset();
    });

    return data;
  }

  /* Переключение и отправка формы в модальном окне */
  function formModal() {
    const modalBtn = document.querySelectorAll('.formModal__modal-btn');

    modalBtn?.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        let target = e.target,
          form = target.closest('.formModal__modal-form');

        e.preventDefault();
        deleteErrors(form);

        if (validate(form)) {
          if (target.type == 'button') {
            btn.setAttribute('data-modal-open', '');
            btn.setAttribute('data-modal-close', '');
          } else if (target.type == 'submit') {
            btn.setAttribute('data-modal-close', '');
            send(form, e, getFormModalData());
          }
        } else {
          if (
            target.closest('[data-modal-close]') &&
            target.closest('[data-modal-open]')
          ) {
            btn.removeAttribute('data-modal-open', '');
            btn.removeAttribute('data-modal-close', '');
          }
        }
      });
    });
  }

  /* Инициализация функций */
  setForm('#form-app');
  setForm('#modal-main');
  setFormCheckbox(
    [
      document.querySelector('#form-check'),
      document.querySelector('#form-check--pd'),
    ],
    document.querySelector('#form-btn')
  );
  setFormCheckbox(
    [
      document.querySelector('#form-check-modal'),
      document.querySelector('#form-check-modal--pd'),
    ],
    document.querySelector('#form-btn-modal')
  );
  resize(resizeForm);
  resizeForm();
  formModal();
  getTop5Programs();

  /* Пользователь находится на сайте больше 30 сек  */
  setTimeout(() => {
    VK.Retargeting.Event('PageView30sec');
    fbq('track', 'PageView30s');
  }, 30000);

  /* Добавление скрипта AdvCake на сайт */
  function addAdvCakeScript(id, OdinId, program, email, advcakeCookie) {
    const pageUrl = document.location.href;

    window.advcake_data = window.advcake_data || [];
    window.advcake_data.push({
      pageType: 6,
      user: {
        email: `md5(${email})`,
        type: '',
      },
      leadInfo: {
        id: `${id}`,
        leadid: `${OdinId}`,
        name: `${program}`,
        totalPrice: 0,
        coupon: '',
        marketing_cat: 1,
        trackId: `${advcakeCookie}`,
        url: `${pageUrl}`,
      },
    });
  }
};

export default form;
